import { useCallback, useEffect, useState } from "react";
import { api } from "../../api.js";
import {
  Badge, Button, EmptyState, Field, LoadingRows, Notice, Table, TableCell,
  TableHead, TableHeader, TableRow,
} from "../../components/ui.jsx";
import PaginationControls from "./PaginationControls.jsx";
import { formatDate } from "./utils.js";

const PAGE_SIZE = 25;

export default function PeopleTab() {
  const [query, setQuery] = useState("");
  const [filters, setFilters] = useState({ search: "", offset: 0 });
  const [state, setState] = useState({ loading: true, people: [], pagination: null, error: "" });

  const load = useCallback(async () => {
    setState((current) => ({ ...current, loading: true, error: "" }));
    try {
      const data = await api.platformCatalogPeople({
        limit: PAGE_SIZE,
        offset: filters.offset,
        ...(filters.search ? { search: filters.search } : {}),
      });
      setState({ loading: false, people: data.people, pagination: data.pagination, error: "" });
    } catch (error) {
      setState((current) => ({ ...current, loading: false, error: error.message }));
    }
  }, [filters]);

  useEffect(() => { load(); }, [load]);

  function search(event) {
    event.preventDefault();
    setFilters({ search: query.trim(), offset: 0 });
  }

  return (
    <div className="grid gap-6">
      <form className="flex max-w-[620px] gap-2" onSubmit={search} role="search">
        <Field
          className="text-base sm:text-sm"
          label="Search shared people"
          placeholder="Name, LinkedIn URL, or verified email"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
        <Button className="mt-[27px]" type="submit">Search</Button>
      </form>
      {state.error && <Notice>{state.error}</Notice>}
      {state.loading ? <LoadingRows count={6} /> : state.people.length ? (
        <>
          <Table>
            <TableHead><TableHeader>Person</TableHeader><TableHeader>Current email</TableHeader><TableHeader>Provider</TableHeader><TableHeader>Workspaces</TableHeader><TableHeader>Freshness</TableHeader><TableHeader>Observed</TableHeader></TableHead>
            <tbody>{state.people.map((person) => (
              <TableRow key={person.id}>
                <TableCell>
                  <strong className="block text-[13px]">{person.name}</strong>
                  <small className="block max-w-[280px] truncate text-[11px] text-muted-foreground">{person.linkedin_url || "No LinkedIn identity"}</small>
                </TableCell>
                <TableCell>{person.current_email?.value || "—"}</TableCell>
                <TableCell>{person.current_email?.provider || "—"}</TableCell>
                <TableCell>{person.workspace_count}<span className="text-muted-foreground"> ({person.workspace_person_count} records)</span></TableCell>
                <TableCell>{person.current_email ? <Badge status={person.current_email.freshness}>{person.current_email.verification_status}</Badge> : "—"}</TableCell>
                <TableCell className="whitespace-nowrap text-muted-foreground">{formatDate(person.current_email?.observed_at)}</TableCell>
              </TableRow>
            ))}</tbody>
          </Table>
          <PaginationControls pagination={state.pagination} onChange={(offset) => setFilters((current) => ({ ...current, offset }))} />
        </>
      ) : <EmptyState title="No shared people found" description="People enter the shared catalog when RevPal can establish a strong LinkedIn, provider, or verified-email identity." />}
    </div>
  );
}
